var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 4.66667H10.6668V3.33333L9.3335 2H6.66683L5.3335 3.33333V4.66667H2.66683C1.9335 4.66667 1.3335 5.26667 1.3335 6V9.33333C1.3335 9.83333 1.60016 10.2533 2.00016 10.4867V12.6667C2.00016 13.4067 2.5935 14 3.3335 14H12.6668C13.4068 14 14.0002 13.4067 14.0002 12.6667V10.48C14.3935 10.2467 14.6668 9.82 14.6668 9.33333V6C14.6668 5.26667 14.0668 4.66667 13.3335 4.66667ZM6.66683 3.33333H9.3335V4.66667H6.66683V3.33333ZM2.66683 6H13.3335V9.33333H10.0002V7.33333H6.00016V9.33333H2.66683V6ZM8.66683 10H7.3335V8.66667H8.66683V10ZM12.6668 12.6667H3.3335V10.6667H6.00016V11.3333H10.0002V10.6667H12.6668V12.6667Z",
    fill: "#101840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTask);
export default __webpack_public_path__ + "static/media/ic_task.3d0dd08241d21f61579ca396e65bf1ee.svg";
export { ForwardRef as ReactComponent };